import { render, staticRenderFns } from "./StatValue.vue?vue&type=template&id=0e3a3db8&scoped=true&"
import script from "./StatValue.vue?vue&type=script&lang=js&"
export * from "./StatValue.vue?vue&type=script&lang=js&"
import style0 from "./StatValue.vue?vue&type=style&index=0&id=0e3a3db8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3a3db8",
  null
  
)

export default component.exports